import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _to_consumable_array from "@swc/helpers/src/_to_consumable_array.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from "react";
import { I18nextProvider } from "react-i18next";
import { initI18n } from "../init/i18next";
var I18Next = function(App) {
    return function _(props) {
        var _pageProps = props.pageProps, pageProps = _pageProps === void 0 ? {} : _pageProps;
        var namespaces = pageProps.namespaces, ssrLanguage = pageProps.ssrLanguage;
        var i18next = useMemo(function() {
            var saneNamespaces = Array.isArray(namespaces) ? namespaces.filter(function(ns) {
                return typeof ns === "string";
            }) : [];
            return initI18n({
                namespaces: [
                    "shared"
                ].concat(_to_consumable_array(saneNamespaces)),
                ssrLanguage: ssrLanguage
            });
        }, []);
        return /*#__PURE__*/ _jsx(I18nextProvider, {
            i18n: i18next,
            children: /*#__PURE__*/ _jsx(App, _object_spread({}, props))
        });
    };
};
export default I18Next;
